import type {} from '@mui/lab/themeAugmentation'
import { type Theme, createTheme } from '@mui/material/styles'

import { theme } from '../theme'
import { scaleFontSize } from './helpers'

/**
 * Standalone theme for VR headset mode.
 * Extends base theme with larger buttons and thicker borders for better VR visibility.
 *
 * Apply using StandaloneThemeProvider wrapper around specific pages/components.
 * Do not apply globally - only wrap components that need VR-optimized styling.
 */
export const standaloneTheme: Theme = createTheme(theme, {
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // Scale FontAwesome icons in standalone mode
        '.svg-inline--fa': {
          fontSize: scaleFontSize(14),
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        outlined: {
          borderWidth: 2,
        },
        sizeSmall: {
          // In standalone mode, small buttons get medium/large sizing for better VR visibility
          padding: theme.spacing(0.75, 2),
          fontSize: scaleFontSize(14),
        },
        sizeMedium: {
          padding: theme.spacing(1.5, 2.5),
          fontSize: scaleFontSize(16),
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        // Effects - PageTitle
        h1: {
          fontSize: scaleFontSize(20),
        },
        // Effects - Feedback Section Title
        h2: {
          fontSize: scaleFontSize(18),
          paddingTop: theme.spacing(),
          paddingBottom: theme.spacing(),
        },
        // Effects - Feedback Item Importance
        caption: {
          fontSize: scaleFontSize(14),
        },
        // Effects - Feedback Item Rationale title
        subtitle2: {
          fontSize: scaleFontSize(14),
        },
        // Effects - Feedback Item time label
        body1: {
          fontSize: scaleFontSize(16),
        },
        body2: {
          fontSize: scaleFontSize(14),
        },
      },
    },
    MuiChip: {
      // Effects - Feedback Item Tags
      styleOverrides: {
        // Make small chips larger and more readable in standalone/VR mode
        sizeSmall: {
          fontSize: scaleFontSize(12),
          padding: theme.spacing(1.5, 0.5),
        },
      },
    },

    MuiLink: {
      // Effects - Rationale Links
      styleOverrides: {
        root: {
          fontSize: scaleFontSize(16),
        },
      },
    },
  },
})
